export const productSearch = () => {
  const searchBox = document.querySelector<HTMLInputElement>(
    "[data-feature=product-search]"
  );

  if (!searchBox) {
    return; // No product search box on the page
  }

  searchBox.value = ""; // Reset any previous search

  searchBox.addEventListener("keydown", event => {
    if (event.key === "Enter") {
      const targetElement = event.target as HTMLInputElement;

      if (!targetElement) {
        throw "Expected an input element";
      }

      const finderUrl = targetElement.dataset.productFinderUrl;

      if (!finderUrl) {
        throw "Search box did not have an expected attribute with the Product Finder URL";
      }

      // Redirect to Product Finder with parameter for free-text search
      document.location = `${finderUrl}?${targetElement.name}=${targetElement.value}`;
    }
  });
};
